import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getHotspotUser,
  getHotspotUserConnect,
  getIspOwner,
} from "../../../features/qrCodeApi";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Card } from "react-bootstrap";
import moment from "moment";
import { badge } from "../../../components/common/Utils";
import { billPayment } from "../../../features/getIspOwnerUsersApi";
import { publicRequest } from "../../../api/apiLink";
import Loader from "../../../components/common/Loader";

const HotspotConnect = () => {
  const dispatch = useDispatch();
  const { ispId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const username = searchParams.get("username");
  const password = searchParams.get("password");
  const mikrotik = searchParams.get("mikrotik");

  const hotspotUser = useSelector((state) => state.publicSlice?.hotspotUser);

  //---> Local State
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ispInfo, setIspInfo] = useState("");

  useEffect(() => {
    if (ispId) getIspOwner(ispId, setLoading, setIspInfo);

    if (username && password && ispId)
      getHotspotUser(dispatch, ispId, username, password, setIsLoading);
  }, [ispId]);

  const handleHotspotCustomerConnect = () => {
    getHotspotUserConnect(hotspotUser?.id, mikrotik, setIsLoading);
  };

  const billPaymentController = async () => {
    const data = {
      amount: hotspotUser?.monthlyFee,
      name: hotspotUser?.name,
      billType: "bill",
      customer: hotspotUser?.id,
      ispOwner: hotspotUser?.ispOwner,
      user: hotspotUser?.user,
      userType: hotspotUser?.userType,
      medium: ispInfo?.bpSettings?.paymentGateway?.gatewayType,
      paymentStatus: "pending",
      mikrotikPackage: hotspotUser?.hotspotPackage,
    };

    billPayment(data, setLoading);
  };

  const bKash = window.bkash;
  let URL = {
    create: "hotspot/bkash/payment-create",
    execute: "hotspot/bkash/payment-execute",
    baseURL: publicRequest,
  };

  useEffect(() => {
    let paymentID = "";
    if (hotspotUser) {
      bKash.init({
        paymentMode: "checkout",
        paymentRequest: {
          amount: hotspotUser.monthlyFee,
          merchantInvoiceNumber: Date.now(),
          intent: "sale",
          ispOwnerId: ispInfo.id,
          billType: "bill",
          hotspotPackage: hotspotUser.hotspotPackage,
          customer: hotspotUser.id,
          name: hotspotUser.name,
          mobile: hotspotUser.mobile,
          password: hotspotUser.hotspot.password,
        },
        createRequest: async function (request) {
          try {
            const { data } = await URL.baseURL.post(URL.create, request);
            if (data?.statusCode === "0000") {
              localStorage.setItem("paymentAmount", hotspotUser?.monthlyFee);
              localStorage.setItem("username", username);
              localStorage.setItem("password", password);

              sessionStorage.setItem("qrispid", hotspotUser?.ispOwner);
              window.location.href = data?.bkashURL;
            }

            if (data?.paymentID) {
              paymentID = data.paymentID;
              bKash.create().onSuccess(data);
            } else {
              bKash.create().onError();
              window.location.href = "/payment/failed";
            }
          } catch (error) {
            bKash.create().onError();
            window.location.href = "/payment/failed";
            console.log(error);
          }
        },
        executeRequestOnAuthorization: async function () {
          const billData = {
            amount: hotspotUser?.monthlyFee,
            name: hotspotUser?.name,
            billType: "bill",
            customer: hotspotUser?.id,
            ispOwner: hotspotUser?.ispOwner,
            user: hotspotUser?.user,
            userType: hotspotUser?.userType,
            medium: ispInfo?.bpSettings?.paymentGateway?.gatewayType,
            paymentStatus: "pending",
            mikrotikPackage: hotspotUser?.hotspotPackage,
          };
          try {
            const { data } = await URL.baseURL.post(
              `${URL.execute}?paymentID=${paymentID}`,
              billData
            );

            if (data.bill.paymentStatus === "paid") {
              window.location.href = "/payment/success";
            } else {
              window.location.href = "/payment/failed";
              bKash.execute().onError();
            }
          } catch (error) {
            bKash.execute().onError();
            window.location.href = "/payment/failed";
          }
        },
      });
    }
  }, [hotspotUser]);

  const gatewayType = ispInfo?.bpSettings?.paymentGateway?.gatewayType;

  return (
    <>
      <ToastContainer theme="colored" />

      <div className="createUserPage">
        <div className="w-100">
          <div className="mainPage">
            <Card className="mainCard mb-4 bg-white rounded mw-100">
              <Card.Title className="userTitle p-2">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <h4 className="company">{ispInfo?.company}</h4>
                  <p className="text-secondary">{ispInfo?.address}</p>
                  <h6 className="text-secondary mb-0">
                    Contact: {ispInfo?.mobile}
                  </h6>
                </div>
              </Card.Title>
              <Card.Body>
                <Card.Title className="clintTitle mb-0">
                  <h5 className="profileInfo">{hotspotUser?.name}</h5>
                </Card.Title>

                <Card.Body>
                  <div>
                    <div className="displayGridHorizontalFill5_5 profileDetails">
                      <p>User Type</p>
                      <p>{badge(hotspotUser?.userType)}</p>
                    </div>

                    <div className="displayGridHorizontalFill5_5 profileDetails">
                      <p>Status</p>
                      <p>{badge(hotspotUser?.status)}</p>
                    </div>

                    <div className="displayGridHorizontalFill5_5 profileDetails">
                      <p>User Name</p>
                      <p>{hotspotUser.hotspot?.name}</p>
                    </div>

                    <div className="displayGridHorizontalFill5_5 profileDetails">
                      <p>Mobile</p>
                      <p>{hotspotUser?.mobile}</p>
                    </div>

                    <div className="displayGridHorizontalFill5_5 profileDetails">
                      <p>Password</p>
                      <p>{hotspotUser?.hotspot?.password}</p>
                    </div>

                    <div className="displayGridHorizontalFill5_5 profileDetails">
                      <p>Package</p>
                      <p>{hotspotUser.hotspot?.profile}</p>
                    </div>

                    <div className="displayGridHorizontalFill5_5 profileDetails">
                      <p>Package Rate</p>
                      <p>৳{hotspotUser?.monthlyFee}</p>
                    </div>

                    {hotspotUser?.userType === "hotspot" && (
                      <div className="displayGridHorizontalFill5_5 profileDetails">
                        <p>Bill Date</p>
                        <p>
                          {moment(hotspotUser?.billingCycle).format(
                            "MMM DD YYYY hh:mm A"
                          )}
                        </p>
                      </div>
                    )}

                    {ispInfo?.bpSettings?.hasPG &&
                    hotspotUser.status === "expired" ? (
                      <div className="d-flex justify-content-end mt-3">
                        <button
                          id={gatewayType === "bKashPG" ? "bKash_button" : ""}
                          onClick={
                            gatewayType !== "bKashPG"
                              ? billPaymentController
                              : () => {}
                          }
                          type="button"
                          className="btn btn-primary"
                        >
                          Payment
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleHotspotCustomerConnect}
                      >
                        {isLoading ? <Loader /> : ""} Connect
                      </button>
                    )}
                  </div>
                </Card.Body>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default HotspotConnect;
